import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { observer } from 'mobx-react-lite';

import {
  SearchProfileScreen,
  SearchTrackScreen,
  SearchTutorialScreen,
} from '@screens';
import { screens } from './screens';
import type { SearchStackParamListType } from './types';
import { WebHeader } from '@components';

const SearchStack =
  createNativeStackNavigator<SearchStackParamListType>();

export const SearchNavigator = observer(() => {
  return (
    <SearchStack.Navigator
      screenOptions={{
        headerShown: true,
        header: () => (
          <WebHeader activeTabButtonName={screens.Search} />
        ),
      }}
    >
      <SearchStack.Screen
        name={screens.SearchTutorial}
        component={SearchTutorialScreen}
      />
      <SearchStack.Screen
        name={screens.SearchTrack}
        component={SearchTrackScreen}
      />
      <SearchStack.Screen
        name={screens.SearchProfile}
        component={SearchProfileScreen}
      />
    </SearchStack.Navigator>
  );
});
